<div class="navigation-container">
  <div
    id="showPrevious"
    data-cy="navigate-to-previous"
    *ngIf="showPrevious"
    class="btn navigation-button navigation-previous"
    (click)="previous()"
  >
    <img src="assets/general/img/arrow-left.svg" alt="'general.navigation.backArrowAlt' | translate" />
    <span>{{ "general.navigation.back" | translate }}</span>
  </div>

  <button
    *ngIf="showNext"
    id="showNext"
    class="btn btn-primary navigation--next w-full md:w-auto"
    [disabled]="disabledNext"
    type="button"
    data-cy="navigate-next"
    (click)="next()"
  >
    {{ "general.navigation.next" | translate }}
  </button>

  <div
    id="showSetDefault"
    data-cy="set-to-default"
    *ngIf="showSetDefault"
    class="btn navigation-button navigation-skip"
    (click)="setDefault()"
  >
    <span>{{ "general.navigation.dontKnow" | translate }}</span>
    <img src="assets/general/img/arrow-right.svg" alt="'general.navigation.dontKnow' | translate" />
  </div>

  <div id="showSkip" data-cy="skip" *ngIf="showSkip" class="navigation-button navigation-skip" (click)="skip()">
    <span>{{ skipText || ("general.navigation.skip" | translate) }}</span>
    <img src="assets/general/img/arrow-right.svg" alt="'general.navigation.skip' | translate" />
  </div>

  <button
    *ngIf="showContinueLater"
    id="showContinueLater"
    class="btn btn-secondary navigation-skip w-full md:w-auto mt-4"
    [class.md:mt-8]="showNext"
    [class.md:mt-0]="!showNext"
    type="button"
    data-cy="continue-later"
    (click)="continueLater()"
  >
    {{ "modules.evcQuote.steps.technicalDetails.steps.intro.finalizeLater" | translate }}
  </button>
</div>
